module.exports = __webpack_public_path__ + "img/bz.3da05104.png";